<template>
  <div class="PerfectInfo">
    <Steps active="1" />
    <div class="field">
        <van-cell-group class="mt8 forms">
            <component v-for="app in comps"
                :is="app.component"
                :label="app.label"
                :placeholder="app.placeholder"
                :max="app.max"
                :min="app.min"
                :model="app.model"
                :value="app.value"
                :columnsTerm="app.columnsTerm"
                :reg="app.reg"
                v-bind:key="app.model"
                :readonly="app.readonly"
            >
            </component>
            <Contract @agree="agree" @showPopup="showPopup"/>
            <van-popup v-model="show">
                <component :is="contract" :hidePopup="hidePopup"></component>
            </van-popup>
            <Button text="下一步"
                type="danger"
                v-if ="buttonShow"
                :disabled="!canGoNext"
                class="next"
                :click="onSubmit"
                :loading="this.$store.state.commonForms.onLoaderSaving"
                loadingText="提交中..."
            />
        </van-cell-group>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Steps from '@/components/Steps.vue';
import Button from '@/components/Button.vue';
import EnterpriseAuthorizationAgreement from '@/components/FeildTwo/components/EnterpriseAuthorizationAgreement.vue';
import DashuH5 from '@/components/FeildTwo/components/DashuH5.vue';
import PersonalAuthorizedAgreement from '@/components/FeildTwo/components/PersonalAuthorizedAgreement.vue';
import InformationCheckAndUseAgreement from '@/components/FeildTwo/components/InformationCheckAndUseAgreement.vue';
import PufaOnlineAuth from '@/components/FeildTwo/components/PufaOnlineAuth.vue';
import PufaStatementUse from '@/components/FeildTwo/components/PufaStatementUse.vue';
import GuaranteeServiceContract from '@/components/FeildTwo/components/GuaranteeServiceContract.vue';


import { Toast } from 'vant';
import Contract from './components/Contract.vue';
import MessageCode from './components/MessageCode.vue';
import LivingPlacePicker from './components/LivingPlacePicker.vue';
import LocatedPlacePicker from './components/LocatedPlacePicker.vue';
import RelatedSelect from './components/RelatedSelect.vue';
import BWSelect from './components/BWSelect.vue';
import RangeInput from './components/RangeInput.vue';
import Input from './components/Input.vue';
import { checkRules } from './util';
import fieldConfig from '../../../configs/fileds';
import { checkStatus } from './mixin';
// import tableConfig from '../../../configs/filedsFormServerLoader.js';
export default {
  name: 'Loader',
  components: {
    Steps,
    RangeInput,
    Input,
    RelatedSelect,
    MessageCode,
    BWSelect,
    Button,
    Toast,
    LocatedPlacePicker,
    LivingPlacePicker,
    Contract,
    EnterpriseAuthorizationAgreement,
    DashuH5,
    PersonalAuthorizedAgreement,
    InformationCheckAndUseAgreement,
    PufaStatementUse,
    PufaOnlineAuth,
    GuaranteeServiceContract,
  },
  data() {
    return {
      loading: true,
      comps: [],
      show: false,
      contract: '',
      buttonShow: false,
    };
  },
  mixins: [checkStatus],
  created() {
    this.$store.dispatch('commonForms/getUiConfig');
    const configTwo = JSON.parse(localStorage.getItem('configTwo'));
    if (configTwo) {
      this.buttonShow = true;
    }
    configTwo.forEach((item) => {
      if (item.type === 'contract') {
        localStorage.setItem('contractMap', JSON.stringify(item.values));
      }
      if (item.type === 'RangeInput') {
        this.comps.push({
          component: RangeInput,
          label: fieldConfig[item.key].label,
          model: item.key,
          placeholder: `${item.min}到${item.max}`,
          min: item.min,
          max: item.max,
          value: item.defaultValue,
        });
      }

      if (item.type === 'BWSelect' || item.type === 'Input' || item.type === 'MessageCode') {
        this.comps.push({
          component: item.type,
          label: fieldConfig[item.key].label || '',
          model: item.key,
          placeholder: fieldConfig[item.key].placeholder || '',
          columnsTerm: item.values || [],
          readonly: fieldConfig[item.key].readonly || false,
          reg: fieldConfig[item.key].reg || [],
        });
      }

      if (item.type === 'LocatedPlacePicker') {
        this.comps.push({
          component: LocatedPlacePicker,
          label: fieldConfig[item.type].label,
          model: item.key,
          placeholder: fieldConfig[item.type].placeholder,
          columnsTerm: '',
          reg: fieldConfig[item.type].reg,
        });
      }

      if (item.type === 'RelatedSelect') {
        this.comps.push({
          component: RelatedSelect,
          label: [fieldConfig[item.type].label1, fieldConfig[item.type].label2],
          model: item.key,
          placeholder: fieldConfig[item.type].placeholder,
          columnsTerm: `${JSON.stringify(item.valuesMarriageStatus)}/${JSON.stringify(item.valuesEmerRelation)}`,
          reg: fieldConfig[item.type].reg,

        });
      }

      if (item.type === 'LivingPlacePicker') {
        this.comps.push({
          component: LivingPlacePicker,
          label: fieldConfig[item.type].label,
          model: item.key,
          placeholder: fieldConfig[item.type].placeholder,
          columnsTerm: '',
          reg: fieldConfig[item.type].reg,
        });
      }
    });
  },
  mounted() {
    document.getElementsByTagName('body')[0].className = 'bgColor';
    this.$store.dispatch('commonForms/fetchInfoFromServer');
    this.$store.dispatch('commonForms/getBasicLegalInfo');
  },
  beforeDestroy() {
    this.$store.dispatch('commonForms/updateCommon', {
      agreeWithAgreement: 0,
      onLoaderSaving: false,
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onSubmit(data) {
      if (this.$store.state.commonForms.agreeWithAgreement === 0) {
        Toast('请勾选协议');
        return;
      }
      const contractArr = [];
      const contractMap = JSON.parse(localStorage.getItem('contractMap')) || [];
      contractMap.forEach((v) => {
        contractArr.push(v.value);
      });
      this.$store.dispatch('commonForms/updateCommon', {
        typeList: contractArr,
      });
      this.$store.dispatch('commonForms/saveLoaderInfo');
    },
    showPopup(val) {
      this.contract = val;
      this.show = !this.show;
    },
    hidePopup() {
      this.show = !this.show;
    },
    agree() {
      let temp;
      // eslint-disable-next-line no-unused-expressions
      this.$store.state.commonForms.agreeWithAgreement === 0 ? temp = 1 : temp = 0;
      this.$store.dispatch('commonForms/updateCommon', {
        agreeWithAgreement: temp,
      });
    },
  },
  computed: {
    /**
         * 是否可以进行跳转到下一个页面
         * 表格的所有值都是已经填写状态
         * 所有值都是合法的状态
         */
    canGoNext() {
      let hasError = false;
      let multiCheck = false;
      const config = JSON.parse(localStorage.getItem('configTwo'));
      config.forEach((item) => {
        if (item.type !== 'contract') {
          // eslint-disable-next-line no-unused-vars
          const {
            max, min, type,
          } = item;
          if (item.key.indexOf('/') > -1) {
            const arry = item.key.split('/');
            arry.forEach((val) => {
              console.log(val);
              if (this.$store.state.commonForms[val] === '') {
                multiCheck = true;
              }
            });
          } else {
            const data = this.$store.state.commonForms[item.key];
            const rules = fieldConfig[item.key].reg;
            const checked = checkRules(data, rules, type, max, min);
            if (checked) {
              hasError = true;
            }
          }
        }
      });
      const {
        onLoaderSaving,

      } = this.$store.state.commonForms;
      return !multiCheck && !hasError && !onLoaderSaving;
    },
  },
};
</script>
<style scoped>
.bgColor {
  background: #f8f8f9;
}
.next {
  margin-top: 48px;
  padding-bottom: 48px;
}
.mt8 {
  margin-top: 8px;
}
.PerfectInfo >>>.van-button--danger {
    color: #fff;
    background-color: #F5514A;
    border: 1px solid #F5514A;
}

.van-popup{
  width: 100%;
}
</style>
